// extracted by mini-css-extract-plugin
export var container = "style-module--container--30575";
export var desc = "style-module--desc--f6fdc";
export var info = "style-module--info--28595";
export var screen1 = "style-module--screen1--a0d3c";
export var timeWrap = "style-module--time-wrap--64192";
export var type = "style-module--type--f1877";